export const shouldNameWrap = (
  name: string,
  availableSpace: number,
  breathingRoomInPx = 15
) => {
  if (!name) throw Error(`Name is not provided: ${name}`);
  // 1ch = 8px;
  const nameLengthInPx = Math.ceil(name.length * 8);
  // import.meta.env.DEV &&
  // console.log(
  //   "[DEV] Name, lengthInPx, available space:",
  //   name,
  //   nameLengthInPx,
  //   availableSpace
  // );
  return availableSpace - nameLengthInPx < breathingRoomInPx;
};
